import React, { FC, ReactNode, SVGProps } from 'react'
import s from './ChevronWithTooltip.module.sass'
import { Tooltip } from '@shared/ui/Overlays/Tooltip'
import { Text } from '@shared/ui/Typography/Text'
import { ErrorBoundary } from '@shared/lib/components/ErrorBoundary'

interface Props {
  icon: FC<SVGProps<SVGSVGElement>>
  className?: string
}

const ChevronWithTooltip: FC<Props> = ({ icon, className = '' }) => {
  const IconChevron = icon
  return (
    <ErrorBoundary>
      <div className={`chevron ${className}`}>
        <Tooltip>
          <Tooltip.Trigger>
            <IconChevron />
          </Tooltip.Trigger>
          <Tooltip.Content>
            <Text sizes={'S'} className={s['tooltip-text']}>
              Выбор Афиши
            </Text>
          </Tooltip.Content>
        </Tooltip>
      </div>
    </ErrorBoundary>
  )
}

export default ChevronWithTooltip
